import Lottie from 'react-lottie';
import colorsClear from './assets/colors_clear_centered.json';
// import colorsBird from './assets/colors_bird.json';
import styles from './Loader.module.scss';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: colorsClear,
  // animationData: colorsBird,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const Loader = (): JSX.Element => (
  <div className={styles.wrapper}>
    <Lottie options={defaultOptions} height={20} width={200} />
  </div>
);

export default Loader;
